import {Validators} from '@angular/forms';

import {ConstraintsCollection, NyseReportFilterModel} from '@spa/api';

import {ComponentTypesEnum} from 'appShared/enums';
import {FilterControlInterface} from 'appShared/interfaces';
import {DatepickerControl, Helper, SelectControl} from 'appShared/classes';
import {Pagination, ReportTableColumn, ReportTableConfigInterface, ReportTableData} from 'appShared/components';
import {EntitlementReportsProvidersEnum} from 'appEntries/panel/enums/entitlement-reports-providers.enum';

export const EntitlementReportPeriodsSelector = 'EntitlementReportPeriods';
export const EntitlementReportProviderSelector = 'EntitlementReportProvider';
export const EntitlementReportDateSelector = 'EntitlementReportDate';
export const EntitlementReportDateFromSelector = 'EntitlementReportDateFrom';
export const EntitlementReportDateToSelector = 'EntitlementReportDateTo';

export const EntitlementReportYearAndMonthSelector = 'EntitlementReportYearAndMonth';
export const EntitlementReportAccountSelector = 'EntitlementReportAccount';
export const EntitlementReportName1Selector = 'EntitlementReportName1';
export const EntitlementReportAddress1Selector = 'EntitlementReportAddress1';
export const EntitlementReportAddress2Selector = 'EntitlementReportAddress2';
export const EntitlementReportCitySelector = 'EntitlementReportCity';
export const EntitlementReportStateSelector = 'EntitlementReportState';
export const EntitlementReportPostCodeSelector = 'EntitlementReportPostCode';
export const EntitlementReportCountrySelector = 'EntitlementReportCountry';
export const EntitlementReportEffDateSelector = 'EntitlementReportEffDate';

export const EntitlementReportSubNameSelector = 'EntitlementReportSubNameSelector';
export const EntitlementReportStateOrProvinceSelector = 'EntitlementReportStateOrProvinceSelector';
export const EntitlementReportVendorAccountNumberSelector = 'EntitlementReportVendorAccountNumberSelector';
export const EntitlementReportProductCodeSelector = 'EntitlementReportProductCodeSelector';
export const EntitlementReportEffectiveDateSelector = 'EntitlementReportEffectiveDateSelector';
export const EntitlementReportQuantitySelector = 'EntitlementReportQuantitySelector';

export const EntitlementReportRecipientIdSelector = 'EntitlementReportRecipientIdSelector';
export const EntitlementReportRecipientActionSelector = 'EntitlementReportRecipientActionSelector';
export const EntitlementReportRecipientNameSelector = 'EntitlementReportRecipientNameSelector';
export const EntitlementReportAccountNumberSelector = 'EntitlementReportAccountNumberSelector';
export const EntitlementReportLocationIdSelector = 'EntitlementReportLocationIdSelector';
export const EntitlementReportLocationActionSelector = 'EntitlementReportLocationActionSelector';
export const EntitlementReportLocationNameSelector = 'EntitlementReportLocationNameSelector';
export const EntitlementReportContactNameSelector = 'EntitlementReportContactNameSelector';
export const EntitlementReportProductIdSelector = 'EntitlementReportProductIdSelector';
export const EntitlementReportProductActionSelector = 'EntitlementReportProductActionSelector';
export const EntitlementReportProductNameSelector = 'EntitlementReportProductNameSelector';
export const EntitlementReportBeginDateSelector = 'EntitlementReportBeginDateSelector';
export const EntitlementReportEndDateSelector = 'EntitlementReportEndDateSelector';
export const EntitlementReportProUsersSelector = 'EntitlementReportProUsersSelector';
export const EntitlementReportNonProUsersSelector = 'EntitlementReportNonProUsersSelector';

export const EntitlementReportNysePeriodFilterKey = 'effDate';
export const EntitlementReportNasdaqPeriodFilterKey = 'effectiveDate';

export const PanelEntitlementReportsFilterControls = (): FilterControlInterface[] => {
    return [
        {
            name: EntitlementReportProviderSelector,
            placeholder: 'Provider',
            controls: [
                new SelectControl({
                    name: EntitlementReportProviderSelector,
                    value: EntitlementReportsProvidersEnum.NYSE,
                    placeholder: 'Provider',
                    validators: [Validators.required],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: Helper.textsHelper().getEntitlementReportsProvidersName(EntitlementReportsProvidersEnum.NYSE),
                            value: EntitlementReportsProvidersEnum.NYSE
                        },
                        {
                            label: Helper.textsHelper().getEntitlementReportsProvidersName(EntitlementReportsProvidersEnum.NASDAQ),
                            value: EntitlementReportsProvidersEnum.NASDAQ
                        },
                        {
                            label: Helper.textsHelper().getEntitlementReportsProvidersName(EntitlementReportsProvidersEnum.NASDAQUTP),
                            value: EntitlementReportsProvidersEnum.NASDAQUTP
                        },
                        {
                            label: Helper.textsHelper().getEntitlementReportsProvidersName(EntitlementReportsProvidersEnum.CBOE),
                            value: EntitlementReportsProvidersEnum.CBOE
                        },
                    ],
                })
            ],
            sortIndex: 1,
            shown: true,
        },
        {
            name: EntitlementReportDateSelector,
            placeholder: 'Date',
            controls: [
                new DatepickerControl({
                    name: EntitlementReportDateFromSelector,
                    value: null,
                    placeholder: 'Date From',
                    maxDate: null,
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 1
                }),
                new DatepickerControl({
                    name: EntitlementReportDateToSelector,
                    value: null,
                    placeholder: 'Date To',
                    maxDate: null,
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 2
                }),
            ],
            sortIndex: 2,
            shown: true
        },
        {
            name: EntitlementReportPeriodsSelector,
            placeholder: 'Period',
            controls: [
                new SelectControl({
                    name: EntitlementReportPeriodsSelector,
                    value: null,
                    placeholder: 'Period',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [],
                })
            ],
            sortIndex: 3,
            shown: true,
        },
    ];
};

export const PanelEntitlementReportsNyseDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: EntitlementReportYearAndMonthSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportAccountSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportName1Selector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportAddress1Selector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportCitySelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportStateSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportPostCodeSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportCountrySelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportEffDateSelector,
            value: null,
            hidden: false
        }),
    ];
};

export const PanelEntitlementReportsNyseDataTableConfig: ReportTableConfigInterface = {
    rows: [],
    columns: [
        new ReportTableColumn({
            label: 'Date',
            selector: EntitlementReportYearAndMonthSelector
        }),
        new ReportTableColumn({
            label: 'Account',
            selector: EntitlementReportAccountSelector
        }),
        new ReportTableColumn({
            label: 'Name1',
            selector: EntitlementReportName1Selector
        }),
        new ReportTableColumn({
            label: 'Address1',
            selector: EntitlementReportAddress1Selector
        }),
        new ReportTableColumn({
            label: 'City',
            selector: EntitlementReportCitySelector
        }),
        new ReportTableColumn({
            label: 'State',
            selector: EntitlementReportStateSelector
        }),
        new ReportTableColumn({
            label: 'Post Code',
            selector: EntitlementReportPostCodeSelector
        }),
        new ReportTableColumn({
            label: 'Country',
            selector: EntitlementReportCountrySelector
        }),
        new ReportTableColumn({
            label: 'Eff Date',
            selector: EntitlementReportEffDateSelector
        }),
    ],
    hiddenColumnIds: [],
    actionMenu: false
};

export const PanelEntitlementReportsNasdaqDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: EntitlementReportYearAndMonthSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportSubNameSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportAddress1Selector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportCitySelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportStateOrProvinceSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportPostCodeSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportCountrySelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportVendorAccountNumberSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportProductCodeSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportEffectiveDateSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportQuantitySelector,
            value: null,
            hidden: false
        }),
    ];
};

export const PanelEntitlementReportsNasdaqDataTableConfig: ReportTableConfigInterface = {
    rows: [],
    columns: [
        new ReportTableColumn({
            label: 'Date',
            selector: EntitlementReportYearAndMonthSelector
        }),
        new ReportTableColumn({
            label: 'Sub Name',
            selector: EntitlementReportSubNameSelector
        }),
        new ReportTableColumn({
            label: 'Address1',
            selector: EntitlementReportAddress1Selector
        }),
        new ReportTableColumn({
            label: 'City',
            selector: EntitlementReportCitySelector
        }),
        new ReportTableColumn({
            label: 'State Or Province',
            selector: EntitlementReportStateOrProvinceSelector
        }),
        new ReportTableColumn({
            label: 'Postal Code',
            selector: EntitlementReportPostCodeSelector
        }),
        new ReportTableColumn({
            label: 'Country',
            selector: EntitlementReportCountrySelector
        }),
        new ReportTableColumn({
            label: 'Vendor Account Number',
            selector: EntitlementReportVendorAccountNumberSelector
        }),
        new ReportTableColumn({
            label: 'Product Code',
            selector: EntitlementReportProductCodeSelector
        }),
        new ReportTableColumn({
            label: 'Effective Date',
            selector: EntitlementReportEffectiveDateSelector
        }),
        new ReportTableColumn({
            label: 'Quantity',
            selector: EntitlementReportQuantitySelector
        }),
    ],
    hiddenColumnIds: [],
    actionMenu: false
};

export const PanelEntitlementReportsCboeDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: EntitlementReportYearAndMonthSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportAddress1Selector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportAddress2Selector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportCitySelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportCountrySelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportRecipientIdSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportRecipientActionSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportRecipientNameSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportAccountNumberSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportLocationIdSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportLocationActionSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportLocationNameSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportStateSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportPostCodeSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportContactNameSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportProductIdSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportProductActionSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportProductNameSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportBeginDateSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportEndDateSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportProUsersSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportNonProUsersSelector,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: EntitlementReportEffectiveDateSelector,
            value: null,
            hidden: false
        }),
    ];
};

export const PanelEntitlementReportsCboeDataTableConfig: ReportTableConfigInterface = {
    rows: [],
    columns: [
        new ReportTableColumn({
            label: 'Date',
            selector: EntitlementReportYearAndMonthSelector
        }),
        new ReportTableColumn({
            label: 'Address1',
            selector: EntitlementReportAddress1Selector
        }),
        new ReportTableColumn({
            label: 'Address2',
            selector: EntitlementReportAddress2Selector
        }),
        new ReportTableColumn({
            label: 'City',
            selector: EntitlementReportCitySelector
        }),
        new ReportTableColumn({
            label: 'Country',
            selector: EntitlementReportCountrySelector
        }),
        new ReportTableColumn({
            label: 'Recipient Id',
            selector: EntitlementReportRecipientIdSelector
        }),
        new ReportTableColumn({
            label: 'Recipient Action',
            selector: EntitlementReportRecipientActionSelector
        }),
        new ReportTableColumn({
            label: 'Recipient Name',
            selector: EntitlementReportRecipientNameSelector
        }),
        new ReportTableColumn({
            label: 'Account Number',
            selector: EntitlementReportAccountNumberSelector
        }),
        new ReportTableColumn({
            label: 'Location Id',
            selector: EntitlementReportLocationIdSelector
        }),
        new ReportTableColumn({
            label: 'Location Action',
            selector: EntitlementReportLocationActionSelector
        }),
        new ReportTableColumn({
            label: 'Location Name',
            selector: EntitlementReportLocationNameSelector
        }),
        new ReportTableColumn({
            label: 'State',
            selector: EntitlementReportStateSelector
        }),
        new ReportTableColumn({
            label: 'Postal Code',
            selector: EntitlementReportPostCodeSelector
        }),
        new ReportTableColumn({
            label: 'Contact Name',
            selector: EntitlementReportContactNameSelector
        }),
        new ReportTableColumn({
            label: 'Product Id',
            selector: EntitlementReportProductIdSelector
        }),
        new ReportTableColumn({
            label: 'Product Action',
            selector: EntitlementReportProductActionSelector
        }),
        new ReportTableColumn({
            label: 'Product Name',
            selector: EntitlementReportProductNameSelector
        }),
        new ReportTableColumn({
            label: 'Begin Date',
            selector: EntitlementReportBeginDateSelector
        }),
        new ReportTableColumn({
            label: 'End Date',
            selector: EntitlementReportEndDateSelector
        }),
        new ReportTableColumn({
            label: 'Pro Users',
            selector: EntitlementReportProUsersSelector
        }),
        new ReportTableColumn({
            label: 'Non Pro Users',
            selector: EntitlementReportNonProUsersSelector
        }),
        new ReportTableColumn({
            label: 'Effective Date',
            selector: EntitlementReportEffectiveDateSelector
        }),
    ],
    hiddenColumnIds: [],
    actionMenu: false
};

export const defaultEntitlementReportNyseFilterModel = (itemsPerPage = Pagination.defaultItemsPerPage) => {
    return new NyseReportFilterModel(
        new ConstraintsCollection(),
        Pagination.defaultPagesChunk - 1,
        NyseReportFilterModel.getCreatedTimeSelector(),
        Pagination.calculateItemsPerPagesChunk(itemsPerPage),
        false
    );
};
